import React from "react";
import { Box, Typography } from "@mui/material";

const LocationMessage = ({ message }) => {
  const loc = message?.location;
  const str = loc == null ? "" : typeof loc === "string" ? loc : (loc?.address || (loc?.latitude != null && loc?.longitude != null ? `${loc.latitude}, ${loc.longitude}` : "") || "");
  if (!String(str).trim()) return null;
  return (
    <Box>
      <Typography>Localização:</Typography>
      <Typography>{str}</Typography>
    </Box>
  );
};

export default LocationMessage;
